import React from "react";
import { Card, ProgressBar } from "react-bootstrap";

export default function WorkingHoursCard(){

return(

<Card className="working-hours-card h-100">

<Card.Body>

<div className="row mb-4">

<div className="col-xl-3">
<p className="label"><span className="dot grey"></span> Total Working hours</p>
<h3>12h 36m</h3>
</div>

<div className="col-xl-3">
<p className="label"><span className="dot green"></span> Productive Hours</p>
<h3>08h 36m</h3>
</div>

<div className="col-xl-3">
<p className="label"><span className="dot yellow"></span> Break hours</p>
<h3>22m 15s</h3>
</div>

<div className="col-xl-3">
<p className="label"><span className="dot blue"></span> Overtime</p>
<h3>02h 15m</h3>
</div>

</div>

<ProgressBar className="timeline-bar">

<ProgressBar now={18} variant="success"/>
<ProgressBar now={10} variant="warning"/>
<ProgressBar now={28} variant="success"/>
<ProgressBar now={17} variant="warning"/>
<ProgressBar now={22} variant="success"/>
<ProgressBar now={5} variant="info"/>

</ProgressBar>

<div className="timeline-time">

{[
"06:00","07:00","08:00","09:00","10:00","11:00",
"12:00","01:00","02:00","03:00","04:00",
"05:00","06:00","07:00","08:00","09:00","10:00","11:00"
].map((t,i)=>(<span key={i}>{t}</span>))}

</div>

</Card.Body>

<style>{`

.working-hours-card{
margin-top:20px;
}

.label{
font-size:14px;
color:#555;
}

.dot{
width:8px;
height:8px;
display:inline-block;
border-radius:50%;
margin-right:6px;
}

.grey{background:#cfcfcf}
.green{background:#19b15f}
.yellow{background:#f4b400}
.blue{background:#2f80ed}

.timeline-bar{
height:20px;
background:#f3f3f3;
margin-bottom:10px;
}

.timeline-time{
display:flex;
justify-content:space-between;
font-size:11px;
color:#666;
}

`}</style>

</Card>

)

}